"use client";
import React, { useState } from "react";
import { useRouter } from "next/navigation";
import * as Yup from "yup";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import LoginForm from "@/app/(public)/login/LoginForm";
import { useLoginMutation } from "@/lib/redux/api/authApi";
import { clearFieldErrors, setFieldErrors } from "@/lib/redux/slices/formSlice";

export default function LoginPage() {
  const [formSubmitted, setFormSubmitted] = useState(false);
  
  const formFields = [
    {
      name: "email",
      label: "Email",
      type: "email",
      validation: Yup.string()
        .trim()
        .email("Invalid email")
        .required("Email is required"),
    },
    {
      name: "password",
      label: "Password",
      type: "password",
      validation: Yup.string().trim().required("Password is required"),
    },
  ];

  const titleConfig = {
    text: "Login",
    className: "text-center text-3xl font-extrabold text-gray-800 mb-4",
    style: {},
  };

  const subtitleConfig = {
    text: "Enter your email and password to login your account",
    className: "text-center text-lg text-gray-600 mb-6",
    style: {},
  };

  const [login] = useLoginMutation();
  const router = useRouter();
  const dispatch = useDispatch();
  const fieldErrors = useSelector((state) => state.form.fieldErrors);

  const handleLoginSubmit = async (data) => {
    try {
      dispatch(clearFieldErrors());
      const response = await login(data).unwrap();
      
      // Save token and user data to cookies
      Cookies.set("token", response.token, { expires: 7 }); // 7 days expiry
      Cookies.set("user", JSON.stringify(response.user), { expires: 7 });
      
      // Mark form as submitted to trigger reset in the form component
      setFormSubmitted(true);
      
      toast.success(response?.message);
      router.push("/dashboard");
    } catch (error) {
            
      if (error?.data?.errors) {
        dispatch(setFieldErrors(error.data.errors));
      }
      
      if (error?.data?.error) {
        toast.error(error.data.error);
      } else if (error?.data?.message) {
        toast.error(error.data.message);
      }
    }
  };

  return (
    <LoginForm
      title={titleConfig}
      subtitle={subtitleConfig}
      fields={formFields}
      onSubmit={handleLoginSubmit}
      fieldErrors={fieldErrors}
      formSubmitted={formSubmitted}
      setFormSubmitted={setFormSubmitted}
    />
  );
}
